import { render, staticRenderFns } from "./bulk-move-to-trash-modal.vue?vue&type=template&id=cd125b90&scoped=true&"
import script from "./bulk-move-to-trash-modal.vue?vue&type=script&lang=ts&"
export * from "./bulk-move-to-trash-modal.vue?vue&type=script&lang=ts&"
import style0 from "./bulk-move-to-trash-modal.vue?vue&type=style&index=0&id=cd125b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd125b90",
  null
  
)

export default component.exports